module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compileNom"
  }, [_c('div', {
    staticClass: "page1 page"
  }, [_c('div', {
    staticClass: "pageItem clear headItme"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "headImg",
    on: {
      "click": _vm.upAvatarStateFn
    }
  }, [(_vm.avatar && _vm.avatar.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.avatarFn
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/yonghu/logo.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        名字\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "请输入您的昵称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        性别\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('span', {
    staticClass: "genderSelect genderMan",
    class: _vm.gender ? 'ShowGenderSelect' : '',
    on: {
      "click": function($event) {
        return _vm.genderFn('男')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-nan"
  }), _vm._v("\n          男\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "genderSelect genderWoman",
    class: !_vm.gender ? 'ShowGenderSelect' : '',
    on: {
      "click": function($event) {
        return _vm.genderFn('女')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xiangxiziliaonv"
  }), _vm._v("\n          女\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        手机号\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    attrs: {
      "placeholder": "请输入您的手机号",
      "readonly": ""
    },
    domProps: {
      "value": _vm.phone && _vm.phone !== '' ? _vm.phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3') : ''
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "page2 page"
  }, [_c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        紧急联系人姓名\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberEcn),
      expression: "memberEcn"
    }],
    attrs: {
      "placeholder": "请输入您的紧急联系人姓名"
    },
    domProps: {
      "value": (_vm.memberEcn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberEcn = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        紧急联系人电话\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberEcp),
      expression: "memberEcp"
    }],
    attrs: {
      "placeholder": "请输入您的紧急联系人电话"
    },
    domProps: {
      "value": (_vm.memberEcp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberEcp = $event.target.value
      }
    }
  })])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "pageItem clear"
  }, [_c('div', {
    staticClass: "pageItemTitle"
  }, [_vm._v("\n        常用目的地\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pageItemContent"
  }, [_c('xk-site-input', {
    attrs: {
      "placeholder": '请输入常用地',
      "name": _vm.alwaysAddShowFn
    },
    on: {
      "onClick": _vm.alwaysAddFn
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "saveItem",
    on: {
      "click": _vm.SaveButFn
    }
  }, [_c('span', {
    staticClass: "saveBut"
  }, [_vm._v("保存")])]), _vm._v(" "), (_vm.hintBox.stateShow) ? _c('xk-hint-box', {
    attrs: {
      "state": _vm.hintBox.state,
      "content": _vm.hintBox.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.upAvatarState) ? _c('xk-up-avatar', {
    attrs: {
      "phone": _vm.loginData.passenger ? _vm.loginData.passenger.phone : '',
      "imgUrl": _vm.avatar
    },
    on: {
      "change": _vm.upAvatarFn
    }
  }) : _vm._e(), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.BoxSave
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82d01d52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compileNom/compileNom.vue
// module id = 552
// module chunks = 0